/**
 * Clive: meganav hover-swap.
 *
 * Hovering a link in a full-width meganav swaps the large promo image to that
 * category's picture. Leaving the panel, or hovering a link with no image,
 * returns to the resting promo (the consult / feature card set in the theme
 * editor).
 *
 * Images are preloaded lazily, on the FIRST time a panel opens — not on page
 * load. Most visitors never open the menu, so preloading on load would spend
 * bandwidth on every page view for nothing; preloading on first open costs
 * nothing up front and limits the swap flash to at most one frame, once.
 *
 * Only links that resolved an image carry data-clive-swap (see
 * snippets/clive-meganav-link-image.liquid). Links without one are wired to
 * restore the resting state, so moving across a column never leaves a stale
 * image showing under an unrelated label.
 *
 * Progressive enhancement: with JS off the swap layer never receives a src and
 * the promo renders exactly as Stiletto ships it.
 */
(function () {
  'use strict';

  var PANEL = '.meganav[data-meganav-type="full_width_meganav"]';

  function initPanel(panel) {
    if (panel.__cliveSwapInit) return;
    panel.__cliveSwapInit = true;

    var layer = panel.querySelector('[data-clive-swap-layer]');
    if (!layer) return;

    var withImage = Array.prototype.slice.call(panel.querySelectorAll('.meganav__nav a[data-clive-swap]'));
    var withoutImage = Array.prototype.slice.call(panel.querySelectorAll('.meganav__nav a:not([data-clive-swap])'));
    if (!withImage.length) return;

    var preloaded = false;
    function preload() {
      if (preloaded) return;
      preloaded = true;
      withImage.forEach(function (a) {
        var img = new Image();
        img.decoding = 'async';
        img.src = a.getAttribute('data-clive-swap');
      });
    }

    var current = '';
    function show(url) {
      if (!url || url === current) return;
      current = url;
      layer.setAttribute('src', url);
      layer.classList.add('is-active');
    }
    function rest() {
      if (!current) return;
      current = '';
      layer.classList.remove('is-active');
    }

    withImage.forEach(function (a) {
      var url = a.getAttribute('data-clive-swap');
      a.addEventListener('mouseenter', function () { show(url); });
      a.addEventListener('focus', function () { show(url); });
    });
    withoutImage.forEach(function (a) {
      a.addEventListener('mouseenter', rest);
      a.addEventListener('focus', rest);
    });
    panel.addEventListener('mouseleave', rest);

    // Preload the moment the panel is first revealed. Stiletto toggles
    // data-hidden on the panel, so that attribute is the open signal.
    if (panel.getAttribute('data-hidden') === 'false') preload();
    new MutationObserver(function () {
      if (panel.getAttribute('data-hidden') === 'false') preload();
    }).observe(panel, { attributes: true, attributeFilter: ['data-hidden'] });
  }

  function boot() {
    document.querySelectorAll(PANEL).forEach(initPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Theme editor re-renders the header section without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
